export default "__VITE_ASSET__DORvllFI__"